import { useFlow } from "@Libs/Flow/hooks/useFlow";
import { SubscribeFlow } from "../Flows/Subscribe/Subscribe";

export const useSubscribeFlow = () => {
  return useFlow(SubscribeFlow);
};
